export default __webpack_public_path__ + "static/media/marker_single_visited.963becd6.svg";